module.exports = __webpack_public_path__ + "assets/client/images/live-events-logo.svg";